import * as ApiTypes from "../types";

export const toApiUrlParams = (
  urlParams: ApiTypes.Client.DeleteFileById.UrlParams
): ApiTypes.Api.DeleteFileById.UrlParams => urlParams;
